import React from 'react';
import TrademarkFooter from './Footer';
import useIsMobile from '../../hooks/useIsMobile';
import { colors, font, layout, space, type } from '../../styles/tokens';

// Consistent flourish spacing — these used to carry ad-hoc margins per page.
export const Flourish = ({ children, tone = colors.sage }) => (
  <span
    style={{
      display: 'inline-block',
      margin: '0 0.6em',
      color: tone,
      fontSize: '0.9em',
      fontFamily: font.mono,
      verticalAlign: 'baseline'
    }}
  >
    {children}
  </span>
);

export const PageHeader = ({ title, subtitle, flourish }) => {
  const isMobile = useIsMobile();

  return (
    <header style={{ marginBottom: space[5] }}>
      <h1 style={{ ...type.h1(isMobile), marginBottom: space[2] }}>{title}</h1>
      {subtitle && (
        <p style={{ ...type.subtitle, margin: 0 }}>
          {subtitle}
          {flourish && <Flourish>{flourish}</Flourish>}
        </p>
      )}
    </header>
  );
};

// Wraps every page: responsive gutters, one measure, one footer.
const PageShell = ({ children, width = 'page' }) => {
  const isMobile = useIsMobile();

  return (
    <div
      style={{
        minHeight: '100vh',
        // top gutter must clear the collapsed nav blob's curve at the text's left edge
        padding: isMobile ? `112px ${space[2]} ${space[6]}` : `112px ${space[6]} ${space[7]}`,
        maxWidth: width === 'prose' ? layout.prose : layout.page,
        margin: '0 auto',
        animation: 'fadeIn 0.5s ease'
      }}
    >
      {children}
      <TrademarkFooter />
    </div>
  );
};

export default PageShell;
